<!-- @format -->

<template>
  <div id="amap">
    <img src="@/assets/img/map.png" class="right-map" />
  </div>
</template>

<script>
import AMapLoader from '@amap/amap-jsapi-loader';
export default {
  name: 'amap',
  props: {
    mapData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      map: null
    };
  },
  mounted() {
    window._AMapSecurityConfig = {
      securityJsCode: 'b5facbbbc8b78148fa9cad18986ee9d5'
    };
    AMapLoader.load({
      key: '11c7610ef04185b5e427a3b525a4a4c9', // 申请好的Web端开发者Key，首次调用 load 时必填
      version: '2.0', // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
      plugins: ['AMap.DistrictSearch'], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
      AMapUI: {
        // 是否加载 AMapUI，缺省不加载
        version: '1.1', // AMapUI 缺省 1.1
        plugins: ['geo/DistrictExplorer'] // 需要加载的 AMapUI ui插件
      },
      Loca: {
        // 是否加载 Loca， 缺省不加载
        version: '2.0' // Loca 版本，缺省 1.3.2
      }
    })
      .then(AMap => {
        var colors = {};
        var GDPSpeed = {
          520000: 0, //贵州
          540000: 0, //西藏
          530000: 8.5, //云南
          500000: 8.5, //重庆
          360000: 8.5, //江西
          340000: 8.0, //安徽
          510000: 7.5, //四川
          350000: 8.5, //福建
          430000: 8.0, //湖南
          420000: 7.5, //湖北
          410000: 7.5, //河南
          330000: 7.0, //浙江
          640000: 7.5, //宁夏
          650000: 7.0, //新疆
          440000: 7.0, //广东
          370000: 7.0, //山东
          450000: 7.3, //广西
          630000: 7.0, //青海
          320000: 7.0, //江苏
          140000: 0, //山西
          460000: 7, // 海南
          310000: 6.5, //上海
          110000: 6.5, // 北京
          130000: 6.5, // 河北
          230000: 6, // 黑龙江
          220000: 6, // 吉林
          210000: 6.5, //辽宁
          150000: 6.5, //内蒙古
          120000: 5, // 天津
          620000: 0, // 甘肃
          610000: 8.5, // 甘肃
          710000: 2.64, //台湾
          810000: 3.0, //香港
          820000: 4.7 //澳门
        };
        var getColorByDGP = function(adcode) {
          if (!colors[adcode]) {
            // 72，74，205
            var gdp = GDPSpeed[adcode];
            if (gdp) {
              colors[adcode] = 'rgb(0,29,174)';
            } else {
              colors[adcode] = 'rgb(72,74,205)';
            }
          }
          return colors[adcode];
        };

        var disCountry = new AMap.DistrictLayer.Country({
          zIndex: 10,
          SOC: 'CHN',
          depth: 1,
          styles: {
            'nation-stroke': '',
            'coastline-stroke': '',
            'province-stroke': '#009ddb',
            'stroke-width': 2,
            fill: function(props) {
              //中国特有字段
              return getColorByDGP(props.adcode_pro);
            }
          }
        });
        var map = new AMap.Map('amap', {
          zooms: [3, 10],
          center: [105.450112, 37.626334],
          zoomEnable: false,
          dragEnable: false,
          zoom: 4.7,
          pitch: 0,
          layers: [disCountry],
          mapStyle: 'amap://styles/aa0125c0fa8ab2720b506780709902bc'
        });

        // // 获取地图城市点geojson
        var districtSearch = new AMap.DistrictSearch({
          level: 'country',
          showbiz: false,
          subdistrict: 2
        });

        var geojson = {
          type: 'FeatureCollection',
          features: []
        };
        var citys = {}; // 所有城市行政区信息
        var len = 0;
        districtSearch.search('中国', (status, result) => {
          let hb = {};
          result.districtList[0].districtList.forEach(item => {
            if (item.adcode == '420000') {
              hb.center = item.center;
            }
            if (item.districtList) {
              item.districtList.forEach(city => {
                len++;
                if (city.adcode == '429004' || city.adcode == '429005' || city.adcode == '429006' || city.adcode == '429021') {
                  city.adcode = '429000';
                  city.center = hb.center;
                  city.name = '省直辖县级行政区划';
                }
                citys[city.adcode] = {
                  type: 'Feature',
                  properties: {
                    cityName: city.name,
                    rank: len
                  },
                  geometry: {
                    type: 'Point',
                    coordinates: [city.center.lng, city.center.lat]
                  }
                };
              });
            }
          });

          this.mapData.forEach(mapitem => {
            if (citys[mapitem.city_id]) {
              geojson.features.push({
                ...citys[mapitem.city_id],
                qty: mapitem.qty
              });
            }
          });
          var top10 = {
            type: 'FeatureCollection',
            features: geojson.features.slice(0, 10)
          };

          // 添加地图点

          var loca = new Loca.Container({
            map
          });

          // 金色点
          var scatter = new Loca.ScatterLayer({
            // loca,
            zIndex: 10,
            opacity: 1,
            visible: true,
            zooms: [3, 10]
          });

          scatter.setSource(
            new Loca.GeoJSONSource({
              data: {
                type: 'FeatureCollection',
                features: geojson.features.filter(item => item.qty >= 1 && item.qty < 50)
              }
            }),
            {
              unit: 'px',
              size: [14, 14],
              texture:
                'data:image/png;base64,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',
              borderWidth: 0
            }
          );
          loca.add(scatter);

          // 橙色点
          var scatter2 = new Loca.ScatterLayer({
            // loca,
            zIndex: 10,
            opacity: 1,
            visible: true,
            zooms: [3, 10]
          });

          scatter2.setSource(
            new Loca.GeoJSONSource({
              data: {
                type: 'FeatureCollection',
                features: geojson.features.filter(item => item.qty >= 50 && item.qty < 100)
              }
            }),
            {
              unit: 'px',
              size: [16, 16],
              texture:
                'data:image/png;base64,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',
              borderWidth: 0
            }
          );
          loca.add(scatter2);

          // 红色点
          var scatter3 = new Loca.ScatterLayer({
            // loca,
            zIndex: 10,
            opacity: 1,
            visible: true,
            zooms: [3, 10]
          });

          scatter3.setSource(
            new Loca.GeoJSONSource({
              data: {
                type: 'FeatureCollection',
                features: geojson.features.filter(item => item.qty >= 100)
              }
            }),
            {
              unit: 'px',
              size: [18, 18],
              texture:
                'data:image/png;base64,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',
              borderWidth: 0
            }
          );
          loca.add(scatter3);
        });
      })
      .catch(e => {
        console.log(e);
      });
  }
};
</script>

<style scoped lang="less">
#amap {
  position: relative;
  flex: 1;
  background-color: rgba(0, 0, 0, 0) !important;
}
.right-map {
  position: absolute;
  width: 271px / 2;
  height: 377px / 2;
  right: 160px / 2;
  bottom: 90px / 2;
}
</style>
